import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItem } from '@mui/material';
import { SaveDialog } from '../../../molecules/saveDialog';

export const SaveItem = () => {
  const { t } = useTranslation();
  const [dialogVisible, setDialogVisible] = useState(false);

  return (
    <>
      <SaveDialog dialogVisible={dialogVisible} setDialogVisible={setDialogVisible} />

      <MenuItem disableRipple onClick={() => setDialogVisible(true)}>
        {t('Save')}
      </MenuItem>
    </>
  );
};
